import React, {useEffect, useState, useRef} from 'react'
import styles from './index.module.css'
import {FaRegTrashAlt} from "react-icons/fa";
import {IoCloseSharp} from 'react-icons/io5';
import {useDispatch, useSelector} from 'react-redux';
import {deleteChat, deleteMessage, loadMessages, sendMessage} from '../../../../../actions/lk';
import {createNotification} from '../../../../notifications/notifications';
import Confirmation from '../../../../Confirmation/Confirmation';
import { useEscapeKey } from '../../../../../hooks';

const Index = ({selectedChat, setSelectedChat}) => {

    const messagesWrapperRef = useRef(null);
    const textareaRef = useRef(null);

    const scrollToBottom = () => {
        const container = messagesWrapperRef.current;
        if (container) {
            container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth',
            });
        }
    };

    const [timer, setTimer] = useState(0);

    useEscapeKey(() => setConfirmation(false)); // Закроется по ESC

    const dispatch = useDispatch();
    const data = useSelector((state) => state.lk.lineMessages);
    const mid = useSelector((state) => state.auth.mid);

    const [localData,
        setLocalData] = useState([]);

    const [confirmation,
        setConfirmation] = useState(false);

    const [replyTo,
        setReplyTo] = useState({id: null, parent: null, newMessage: ''});

    useEffect(() => {
        if (data?.length > localData?.length) {
            scrollToBottom();
        }
        setLocalData(data);
    }, [data]);

    useEffect(() => {
        dispatch(loadMessages(selectedChat.id));
        setTimeout(() => {
            setTimer(timer + 1);
        }, 3000);
        
    }, [selectedChat, timer]);

    const handleReply = (msg) => {
        setReplyTo(msg);

        setTimeout(() => {
            scrollToBottom();
        }, 100);
        if (textareaRef.current) {
            textareaRef.current.focus();
        }

    };

    useEffect(() => {
        setReplyTo({id: null, parent: null, newMessage: ''});

        setTimeout(() => {
            scrollToBottom();
        }, 100);

    }, [selectedChat?.id]);

    const handleSend = () => {
        if (replyTo
            ?.newMessage.trim().length < 1) 
            return createNotification('error', 'Введите сообщение');
        dispatch(sendMessage(replyTo
            ?.newMessage, selectedChat.id, replyTo
            ?.parent, replyTo
            ?.id));
        setReplyTo({id: null, parent: null, newMessage: ''});

        setTimeout(() => {
            scrollToBottom();
        }, 100);
    };

    const acceptConfirmation = () => {
        // Рекурсивная функция для удаления сообщений с вложениями
        const deleteMessageRecursive = (chatId, message) => {
            dispatch(deleteMessage(chatId, message.id));

            if (message.arr && message.arr.length > 0) {
                message.arr.forEach((child) => {
                    deleteMessageRecursive(chatId, child);
                });
            }
        };

        if (confirmation?.type === 'message') {
            const targetMsg = localData.find(el => el.id === confirmation.msgId);
            if (targetMsg) {
                deleteMessageRecursive(confirmation.chatId, targetMsg);
            }
        } else {
            dispatch(deleteChat(confirmation.chatId));
            setSelectedChat(null);
        }

        setConfirmation(false);
    };

    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    const renderMessage = (msg, isReply = false) => {
        const isOwn = msg.from === mid;
        const replyPreview = isReply && (
            <div className={styles.replyTo}>
                Ответ на сообщение:
                <span title={msg.message}>{msg.message.slice(0, 50)}...</span>
            </div>
        );

        return (
            <div
                key={msg.id}
                className={`${styles.messageItem} ${isOwn
                ? styles.own
                : styles.other}`}>

                {confirmation && (<Confirmation
                    top="30px"
                    left="40px"
                    title={`Удалить ${confirmation
                    ?.type === 'message'
                        ? 'сообщение'
                        : 'диалог'}`}
                    postTitle={`Вы действительно хотите удалить ${confirmation
                    ?.type === 'message'
                        ? 'сообщение'
                        : 'диалог'}?`}
                    confirmation={confirmation}
                    acceptConfirmation={() => acceptConfirmation(confirmation)}
                    rejectConfirmation={rejectConfirmation}/>)}

                <div className={styles.messageMeta}>
                    <div>
                        <span className={styles.author}>{isOwn
                                ? 'Вы'
                                : msg.fromname}</span>
                        <span className={styles.date}>{msg.created}</span>
                    </div>

                    {isOwn
                        && (<FaRegTrashAlt
                            className={styles.iconBtn}
                            title="Удалить сообщение"
                            onClick={() => setConfirmation({
                            chatId: selectedChat
                                ?.id,
                            msgId: msg
                                ?.id,
                            type: 'message'
                        })}/>)}
                </div>

                  {
                        localData?.find(el => el.id === msg.parent) && (
                            <div className={styles.children}>
                                Ответ на сообщение: {localData?.find(el => el.id === msg.parent)?.message}
                            </div>
                        )
                    }

                {replyPreview}
                <div className={styles.messageText}>{msg.message}</div>
                
                <div className={styles.reply} onClick={() => handleReply(msg)}>
                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.0417 12.0413V8.87467C13.0417 8.21495 12.8108 7.65419 12.349 7.19238C11.8872 6.73058 11.3264 6.49967 10.6667 6.49967H3.40313L6.25312 9.34967L5.125 10.458L0.375 5.70801L5.125 0.958008L6.25312 2.06634L3.40313 4.91634H10.6667C11.7618 4.91634 12.6953 5.30228 13.4672 6.07415C14.2391 6.84603 14.625 7.77954 14.625 8.87467V12.0413H13.0417Z" fill="#7D2E2D"/>
                    </svg>

                    <span>Ответить</span>
                    </div>
            </div>
        );
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div className={styles.title}>Тема: {selectedChat.title}</div>
                {
                selectedChat.from === mid &&
                <div 
                className={styles.deleteChat} 
                onClick={() => setConfirmation({chatId: selectedChat.id, type: 'chat'})}>
                    <FaRegTrashAlt/>
                    <span>Удалить диалог</span>
                </div>
                }
            </div>

            <div ref={messagesWrapperRef} className={styles.messagesWrapper}>
                {data?.map((msg) => renderMessage(msg))}

                {replyTo
                    ?.id && (
                        <div className={styles.replyBanner}>
                            <div>Ответ на: <b>{replyTo
                                        .message
                                        .slice(0, 75)}{replyTo.message.length > 75 && '...'}</b>
                            </div>
                            <span className={styles.cancelReply} onClick={() => setReplyTo(null)}><IoCloseSharp/></span>
                        </div>
                    )
                }

            </div>

            <div className={styles.answerWrapper}>
                <svg
                    className={styles.answerIcon}
                    onClick={handleSend}
                    width="32"
                    height="28"
                    viewBox="0 0 32 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 27.3334V0.666748L31.6667 14.0001L0 27.3334ZM3.33333 22.3334L23.0833 14.0001L3.33333 5.66675V11.5001L13.3333 14.0001L3.33333 16.5001V22.3334Z"
                        fill="#7D2E2D"/>
                </svg>

                <textarea
                    ref={textareaRef}
                    className={styles.answer}
                    placeholder="Введите сообщение..."
                    value={replyTo
                    ?.newMessage}
                    onChange={(e) => setReplyTo({
                    ...replyTo,
                    newMessage: e.target.value
                })}/>
            </div>

        </div>
    )
}

export default Index